import { z } from 'zod'

import { FormContext } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'
import { createNodeSidepanelSchema } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'

export type TaskHandlerType = 'create_manual_task'

export const createTaskFormSchema = (formContext: FormContext) => {
  return createNodeSidepanelSchema(formContext).extend({
    nodeType: z.literal('task'),
    nodeData: z.object({
      handlerType: z.string(),
      payload: z.object({}),
    }),
  })
}

export type TaskFormSchema = z.infer<ReturnType<typeof createTaskFormSchema>>
